import { baseTheme } from '@ljagis/react-mui-themes';
import { createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme(baseTheme, {
  palette: {
    primary: {
      main: '#00897b',
      light: '#4ebaaa',
      dark: '#005b4f',
    },
    secondary: {
      main: '#355D98',
      light: '#688ac9',
      dark: '#003469',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  shape: {
    borderRadius: 2,
  },
});

export default theme;
